import config from '../../../../config/config'
import library from '../../../../utils/Library'

const notifyUserEuthCAC = (email, appCode, callback) => {
  const URL_JOBS_EAUTH = library.getBaseAPIUrl('e_auth_url_JOB')
  const URL_NOTIFY_USER_EAUTH_CAC = library.getBaseAPIUrl(
    'e_auth_notify_user_CAC'
  )

  const requestOptionsJobs = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      key: config.KEY_JOBS
    })
  }

  try {
    fetch(URL_JOBS_EAUTH, requestOptionsJobs)
      .then((response) => response.json())
      .then((data) => {
        if (data?.error) return callback(null)

        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${data.jwt2}`
          },
          body: JSON.stringify({
            email: email,
            appCode: appCode
          })
        }

        fetch(URL_NOTIFY_USER_EAUTH_CAC, requestOptions)
          .then(async (response) => {
            const data = await response.json()
            if (response.status !== 302) {
              // eslint-disable-next-line
              return callback({ code: true, api: data.api });
            }
            document.cookie = `syserrepar_JWT2=${data.jwt2}; domain=.errepar.com; path=/; max-age=43200; SameSite=None; Secure;`

            // eslint-disable-next-line
            callback({ message: "Login exitoso", data: data.jwt2 });
            // domain=.errepar.com;
          })
          .catch(() => callback(null))
      })
  } catch (error) {
    callback(null)
  }
}
export default notifyUserEuthCAC
